import AccountManagerPipeline from './AccountManagerPipeline';

export default AccountManagerPipeline;
